module.exports = __webpack_public_path__ + "bbf1b24b1f052ddbc66edf1360ae4d82.webm";


//////////////////
// WEBPACK FOOTER
// ./src/components/cover/cover-mobile.webm
// module id = 262
// module chunks = 1